import { Application } from '@hotwired/stimulus';
import { definitionsFromGlob } from 'stimulus-vite-helpers';

import '../../../initializers/jquery_setup';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import '../../../initializers/polyfill_closest';

import 'jquery-ui/dist/jquery-ui';
import 'jquery-ujs';
import 'jquery-validation/dist/jquery.validate';
import 'jquery-validation/dist/localization/messages_ja';
import 'slick-carousel';
import '../../../vendor/jquery.autoKana';
import '../../../vendor/readmore';

import '../../../initializers/validates';
import '../../../initializers/exists';
import '../../../initializers/prevent_enter_submit';
import '../../../initializers/submit_handler';
import '../../../initializers/autokana';

import 'normalize.css/normalize.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'jquery-ui/themes/base/dialog.css';
import '../../../symbols/style.css';
import '../../../joblist/pc/stylesheets/application.scss';

import.meta.glob('../../../joblist/pc/src/**/*.js', { eager: true });
import.meta.glob('../../../joblist/common/**/*.js', { eager: true });

const application = Application.start();
const modules = import.meta.glob('../../../joblist/controllers/**/*.js', { eager: true });
application.load(definitionsFromGlob(modules));
